export var OnboardingType;

(function (OnboardingType) {
  OnboardingType["none"] = "none";
  OnboardingType["megaMenu"] = "megaMenu";
  OnboardingType["megaMenuLive"] = "megaMenuLive";
  OnboardingType["slider"] = "slider";
  OnboardingType["sliderLive"] = "sliderLive";
})(OnboardingType || (OnboardingType = {}));

export var CSPOnboardingDataTestId;

(function (CSPOnboardingDataTestId) {
  CSPOnboardingDataTestId["megaMenu"] = "mega-menu-wrapper";
  CSPOnboardingDataTestId["slider"] = "csp-carousel-overaly-wrap";
})(CSPOnboardingDataTestId || (CSPOnboardingDataTestId = {}));